import React from "react";

import { Grid } from "@material-ui/core";

import { InputText } from "../../../../components";
import InputLookupMembers from "../../../basics/lookup/members";

export default function ArquivosSaidas({ atributos, setAtributos }) {
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <InputLookupMembers
                        roleMember="branch"
                        label="Estabelecimento"
                        value={atributos.branch}
                        onChangeValue={(data) =>
                            setAtributos({
                                ...atributos,
                                branch: {
                                    id: data.id,
                                    document: data.document,
                                    name: data.name,
                                    type_member: data.type_member,
                                    state_id: data.state_id,
                                    city_name: data.city_name,
                                    city_id: data.city_id,
                                },
                            })
                        }
                        required={true}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ paddingTop: "8px" }}>
                <Grid item xs={2}>
                    <InputText
                        label="Dia Emissão"
                        type="number"
                        min="1"
                        max="31"
                        value={atributos?.dia || 5}
                        onChangeValue={(e) => setAtributos({ ...atributos, dia: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Dia Vencimento"
                        type="number"
                        min="1"
                        max="31"
                        value={atributos?.dia_vencimento || 20}
                        onChangeValue={(e) => setAtributos({ ...atributos, dia_vencimento: e.target.value })}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export function ValidadeArquivosSaidas(data) {
    const message = [];

    if (!data?.branch?.id) {
        message.push("Informe o estabelecimento para geração.");
    }

    return {
        status: message.length === 0,
        data: {
            estabelecimento: data?.branch?.id,
            cnpj: data?.branch?.document,
            uf: data?.branch?.state_id,
            cidade: data?.branch?.city_id,
            dia: Number(data?.dia) || 5,
            dia_vencimento: Number(data?.dia_vencimento) || 20,
        },
        message,
    };
}
